module.exports = __webpack_public_path__ + "static/tab2-8c66df4bbfed0c116826e3501814d665.png";